





let apiBase = {
  queryDevelopersConferenceDetail: '/api/p/activity/detail',
  developersConferencePhoneCheck: '/api/p/activity/phoneCheck',
  sendRegistrationConfirmSms: '/api/p/tool/sendRegistrationConfirmSms',
  registrations: '/api/p/activity/registrations',
  getmVerificationCode: '/api/p/activity/getmVerificationCode',


}
let singleDevelopersConferenceServerObject = null

class DevelopersConferenceServer {
    constructor() {}
    queryDevelopersConferenceDetail(params = {}) {
        return $http({
            method: 'get',
            url: apiBase.queryDevelopersConferenceDetail,
            params: params,
        })
    }
    developersConferencePhoneCheck(data = {}) {
      return $http({
          method: 'post',
          url: apiBase.developersConferencePhoneCheck,
          data: data,
      })
    }
    sendRegistrationConfirmSms(data = {}) {
      return $http({
          method: 'post',
          url: apiBase.sendRegistrationConfirmSms,
          data: data,
      })
    }
    registrations(data = {}) {
      return $http({
          method: 'post',
          url: apiBase.registrations,
          data: data,
      })
    }
  getmVerificationCode(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.getmVerificationCode,
      params,
    })
  }
}

function singleDevelopersConferenceServer() {
    if (singleDevelopersConferenceServerObject === null) {
        singleDevelopersConferenceServerObject = new DevelopersConferenceServer()
    }
    return singleDevelopersConferenceServerObject
}

export default singleDevelopersConferenceServer()
